<template>
	<svg
		width="5px"
		height="23px"
		viewBox="0 0 5 23"
		version="1.1"
		xmlns="http://www.w3.org/2000/svg"
		xmlns:xlink="http://www.w3.org/1999/xlink"
		alt="dot menu icon"
	>
		<g
			id="Symbols"
			stroke="none"
			stroke-width="1"
			fill="none"
			fill-rule="evenodd"
		>
			<g
				id="Chat-/-Header"
				transform="translate(-1108.000000, -20.000000)"
				fill="#B7B9BD"
			>
				<g id="Icon-/-More" transform="translate(1098.000000, 20.000000)">
					<g id="Group-21-Copy" transform="translate(10.000000, 0.000000)">
						<circle id="Oval-Copy" cx="2.5" cy="2.5" r="2.5" />
						<circle id="Oval-Copy-2" cx="2.5" cy="11.5" r="2.5" />
						<circle id="Oval-Copy-3" cx="2.5" cy="20.5" r="2.5" />
					</g>
				</g>
			</g>
		</g>
	</svg>
</template>

<script>
export default {
	name: 'DotMenuIcon',
}
</script>
